import {
    WarehousePageReq,
    WarehousePageResp,
  } from "./manage.interface";
  import { HttpService } from "@/core";
  
  export class WarehouseService {
    static useProjectPageApi() {
      const api = (data: WarehousePageReq) =>
        HttpService.axios({
          method: "POST",
          url: "/manage_warehouse/project/page",
          data,
        });
      return HttpService.usePagination<WarehousePageResp>(api);
    }
  
    static useWarePageApi() {
      const api = (data: WarehousePageReq) =>
        HttpService.axios({
          method: "POST",
          url: "/manage_warehouse/page",
          data,
        });
      return HttpService.usePagination<WarehousePageResp>(api);
    }
    static usePricePageApi() {
      const api = (data: WarehousePageReq) =>
        HttpService.axios({
          method: "POST",
          url: "/manage_warehouse/getMaterialPriceChange",
          data,
        });
      return HttpService.usePagination<WarehousePageResp>(api);
    }

    static useEntryExitPageApi() {
      const api = (params: WarehousePageReq) =>
        HttpService.axios({
          method: "GET",
          url: "/project_material_stock/outPutStorage/record/page",
          params,
        });
      return HttpService.usePagination<WarehousePageResp>(api);
    }
}
  